import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { PaddedContainer, FlexContainer } from '../../styles/Global.styles';
import { MenuIcon, NavMenuContainer, MenuItem, BackgroundContainer } from '../../styles/Navbar.styles';
import { AiOutlineClose } from 'react-icons/ai';
import { motion } from 'framer-motion';
import { slideInLeft, slideInDown } from '../../utils/MotionVariants';
import { Theme } from '../../utils/Theme';

const NavMenu = ({ setMenuOpen }) => {
  const sections = ['Home', 'Skills', 'Projects', 'Contact'];
  const isMobile = useMediaQuery({ maxWidth: Theme.breakpoints.mobile });

  const selectedVariant = isMobile ? slideInDown : slideInLeft;

  return (
    <BackgroundContainer>
      <NavMenuContainer
        as={motion.div}
        variants={selectedVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <PaddedContainer left="5%" right="8%" top="1.6rem">
          <FlexContainer justify="flex-end" responsiveFlex>
            <MenuIcon
              as={motion.a}
              whileHover={{ scale: 1.2 }}
              onClick={() => setMenuOpen(false)}
            >
              <AiOutlineClose />
            </MenuIcon>
          </FlexContainer>
        </PaddedContainer>

        <PaddedContainer top="8%" bottom="8%">
          <FlexContainer
            direction="column"
            align="center"
            responsiveFlex
          >
            {sections.map((section) => (
              <React.Fragment key={section}>
                <MenuItem
                  as={motion.a}
                  whileHover={{ scale: 1.2 }}
                  href={`#${section}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {section}
                </MenuItem>
                <div style={{ height: '20px', width: '90%' }} />
              </React.Fragment>
            ))}
          </FlexContainer>
        </PaddedContainer>
      </NavMenuContainer>
    </BackgroundContainer>
  );
}

export default NavMenu;
